module.exports = __webpack_public_path__ + "static/media/about-certificate-img5.e4aaeb27.jpg";